import React from 'react'
import { Router } from '@reach/router'

import { Editor, Reader, Renderer, NotFound } from '~/pages/'

const AppRouter = () => (
  <Router>
    <NotFound default path="404/" />

    {/* Editor */}
    <Editor path="/enrolment-form/service/:serviceId/editor" />

    {/* Default, blank form */}
    <Renderer path="/enrolment-form/service/:serviceId/renderer" />

    {/* Form pre-filled with waitlist child data */}
    <Renderer path="/enrolment-form/service/:serviceId/child/:childId/renderer" />

    {/* Re-enrolment with pre-filled data, combination of Read-Only and Editable fields */}
    <Renderer path="/enrolment-form/service/:serviceId/child/:childId/guid/:guid/renderer" />

    {/* Form pre-filled with third party data */}
    <Renderer path="/enrolment-form" />

    {/* Pre-Filled Read-Only form viewer */}
    <Reader path="/enrolment-form/service/:serviceId/child/:childId/read" />

    {/* Pre-Filled Read-Only form viewer for Re-Enrolment */}
    <Reader path="/re-enrolment-form/service/:serviceId/guid/:guid/read" />
  </Router>
)

export default AppRouter
